import React from 'react';

import ToolsContainer from 'src/containers/ToolsContainer';
import tools from 'src/consts/tools';
import ErrorBoundary from 'src/ErrorBoundary';


const App = () => (
  <ErrorBoundary>
    <ToolsContainer tools={ tools } />
  </ErrorBoundary>
);


export default App;
